<template>
  <div
    class="spinner-wheel-label _container"
    :style="{'background-color': backgroundColor}"
    :class="[
      `--${variant}`,
      {
        '--initial': !text,
        '--winning': showWinner,
      },
    ]"
  >
    <div class="spinner-wheel-label _prompt" v-if="!text">
      {{ $t('pressToSpinTheWheel') }}
    </div>
    <!-- Initially, 'text' is set when the wheel starts spinning. It changes to the winner's name after the spin. -->
    <div class="spinner-wheel-label _text" v-if="text">
      {{ text }}
    </div>
  </div>
</template>

<script>
export default {
  props: {
    text: {
      type: String,
      default: '',
    },
    backgroundColor: {
      type: String,
      default: '',
    },
    variant: {
      type: String,
      default: 'white',
    },
    showWinner: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/variable.scss";
.spinner-wheel-label {
  &._container {
    font-size: 20px;
    max-width: $spinner-wheel-left-part-width;
    @apply rounded-lg text-center w-full py-2;

    &._popup {
      min-width: $spinner-wheel-left-part-width;
      max-width: $spinner-wheel-winner-width;
      width: unset;
    }
  }

  &._text {
    @apply px-4 text-base-0 truncate font-bold;
  }

  &.--white.--initial {
    @apply bg-base-0 border-secondary-15;
    border-width: 1.5px;
  }

  &.--dark {
    @apply text-base-60;
    background-color: rgba(10, 10, 10, 0.4);
  }

  &.--winning {
    transition: all 0.3s ease-in-out;
    transform: translate(244px, 203px) scale(1.5);
    opacity: 0;
  }
  .keyboard-enter {
    padding: 6px 8px;
    border-radius: 4px;
    background-color: #E6E6E6;
  }
}
</style>
<style lang="scss">
.spinner-wheel-label {
  > span {
    padding: 6px 8px;
    border-radius: 4px;
    display: inline-flex;
    background-color: #E6E6E6;

    > img {
      filter: invert(1);
    }
  }
}
</style>
